import { render, staticRenderFns } from "./courtMediator.vue?vue&type=template&id=132904d4&scoped=true&"
import script from "./courtMediator.vue?vue&type=script&lang=js&"
export * from "./courtMediator.vue?vue&type=script&lang=js&"
import style0 from "./courtMediator.vue?vue&type=style&index=0&id=132904d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132904d4",
  null
  
)

export default component.exports